import { Link } from "react-router-dom";
import "./Nav.css";

export default function Nav({ className }) {
  return (
    <nav>
      <ul className={className}>
        <li>
          <Link to="/" role="button">
            Home
          </Link>
        </li>
        <li>
          <Link to="/about" role="button">
            About
          </Link>
        </li>
        <li>
          <Link to="/menu" role="button">
            Menu
          </Link>
        </li>
        <li>
          <Link to="/booking" role="button">
            Reservations
          </Link>
        </li>
        <li>
          <Link to="/order" role="button">
            Order Online
          </Link>
        </li>
        <li>
          <Link to="/login" role="button">
            Login
          </Link>
        </li>
      </ul>
    </nav>
  );
}
